<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import MediaManager from './../../../MediaManager/layout/MediaManager.vue'
	import Multiselect from 'vue-multiselect'
	//import Extras from './Extras.vue'
	import Extras from './../../extras/layout/Extras.vue'
	import Operations from './../../operations/layout/Operations.vue'
	import AttributeComposer from './AttributeComposer.vue'
	import AttributeFormula from './AttributeFormula.vue'
	import Treeselect from '@riophae/vue-treeselect'
	import Groups from './../components/groups/layout/Groups.vue'
	import PriceList from './../components/priceList/layout/PriceList.vue'
	import Profit from './Profit'
	import Alerts from './../components/alerts/layout/Alerts.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'media-manager': MediaManager,
			'multiselect': Multiselect,
			'extras': Extras,
			'operations': Operations,
			'attribute-composer': AttributeComposer,
			'formula': AttributeFormula,
			'treeselect': Treeselect,
			'groups': Groups,
			'price-list': PriceList,
			'profit': Profit,
			'alerts': Alerts,
		},
		data () {
			return {
				dropzoneImg: {
					accepted: this.$env.ACCEPTED_DROPZONE_IMAGES,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin',
					maxFileSizeInMB: 20,
					maxNumberOfFiles: null,
				},

				dropzoneDoc: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin',
					maxFileSizeInMB: 20,
					maxNumberOfFiles: null,
				},

				statuses: null,
				categories: null,
				operations: null,
				measurementsUnit: null,
				taxes: null,
				attributeLists: null,
				typeFields: null,

				providers: null,

				currencies: null,
				languages: null,

				item: null,

				attribute: null,
				measurementUnit: null,
				tax: null,
				currency: null,

				viewAttribute: null,
				options: null,
				values: null,

				totalPriceOutExtras: null,
				purchaseTotalPriceOutExtras: null,

				valuesMultiselectSearch: [],
				searchAttributeValuesLoading: false,

				stock: {
					quantity: 0,
					usable_quantity: 0,
					product_id: null,
					wherehouse: null,
				},
			}
		},
		created() {
			this.init()
		},
		mounted() {
			this.$validator.extend('usedReference', {
				getMessage: field => 'Refencia no disponible.',
				validate: (value, [testProp]) => {
					if(value) {
						var data = {
							reference: value,
							id: this.$route.params.id,
						}

						return this.$http.post('admin/management/products/validation/reference', data)
						.then(response => {
							return {
								valid: response.body.valid
							}
						}).catch(function(response) {
							console.log(response)
						})
					} else {
						return false
					}
				}
			});

			[].slice.call(document.querySelectorAll('.sttabs')).forEach(function(el) {
				new CBPFWTabs(el);
			})
		},
		watch: {
			'measurementUnit' () {
				this.item.measurement_unit_id = this.measurementUnit.id
				this.item.measurement_unit = this.measurementUnit
			},
			'tax' () {
				if(this.tax) {
					this.item.tax_id = this.tax.id
				} else {
					this.item.tax_id = null
				}
				this.calculatePurchaseTaxes()
				this.calculatePurchasePrice()
				this.calculatePurchaseAmount()
				this.calculatePurchaseTotal()

				this.calculateTaxes()
				this.calculatePrice()
				this.calculateAmount()
				this.calculateTotal()
			},
			'currency' () {
				if(this.currency) {
					this.item.currency_id = this.currency.id
				} else {
					this.item.currency_id = null
				}
			},
			'item.product_operation_id' () {
				this.calculateTotalMeasurementUnit()
			},
			'item.total_measurement_unit' () {
				this.item.total_measurement_unit = this.$options.filters.checkDecimalsMeasurementUnit(this.item.total_measurement_unit)
				this.calculatePurchaseTotal()
				this.calculateTotal()
				this.$nextTick( () => this.$refs.profit.calculateProfit())
			},
			//-- PURCHASE
				'item.purchase_base_price' () {
					this.item.purchase_base_price = this.$options.filters.checkDecimals(this.item.purchase_base_price)
					this.calculatePurchaseSave()
					this.calculatePurchasePrice()
					this.calculatePurchaseTaxes()
					this.calculatePurchaseAmount()
					this.calculatePurchaseTotal()
					this.$nextTick( () => this.$refs.profit.calculateProfit())
				},
			//-- PURCHASE

			//-- SALE
				'item.base_price' () {
					this.item.base_price = this.$options.filters.checkDecimals(this.item.base_price)
					this.calculateSave()
					this.calculatePrice()
					this.calculateTaxes()
					this.calculateAmount()
					this.calculateTotal()
					this.$nextTick( () => this.$refs.profit.calculateProfit())
				},
			//-- SALE

			'stock.usable_quantity'() {
				this.stock.quantity = this.stock.usable_quantity
			}
		},
		methods: {
			stockChange() {
				this.stock.usable_quantity = 0
			},
			init() {
				this.getData()
				this.getStatuses()
				this.getCategories()
				this.getProviders()
				this.getMeasurementsUnit()
				this.getAttributeLists()
				this.getOperations()
				this.getLanguages()
				this.getCurrencies()
				this.getTaxes()
				this.getImages()
				this.getDocs()
			},
			reload() {
				this.getData()
			},
			getData() {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/management/products/' + id + '/edit')
						.then(response => {
							this.item = response.body
							this.measurementUnit = this.item.measurement_unit
							this.tax = this.item.tax
							this.currency = this.item.currency

							this.dropzoneImg.url =  process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/' + this.item.id

							this.dropzoneDoc.url =  process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/' + this.item.id

							if(this.item.stock) {
								this.stock = this.item.stock
							} else {
								this.stock.product_id = this.item.id
							}

							var media = {
								images: [],
								docs: [],
							}

							this.$set(this.item, 'media', media)
							this.getImages()
							this.getDocs()
						})
				}
			},
			getImages() {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/management/products/' + id + '/media/images')
						.then(response => {
							this.item.media.images = response.body
						})
				}
			},
			getDocs() {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/management/products/' + id + '/media/docs')
						.then(response => {
							this.item.media.docs = response.body
						})
				}
			},
			getStatuses: function() {
				this.$http.get('admin/management/products/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			getCategories: function() {
				this.$http.get('admin/management/products/categories')
					.then(response => {
						this.categories = response.body
					})
			},
			getCurrencies: function() {
				this.$http.get('admin/cms/currencies')
					.then(response => {
						this.currencies = response.body
					})
			},
			getTaxes: function() {
				this.$http.get('admin/management/taxes')
					.then(response => {
						this.taxes = response.body
					})
			},
			getLanguages() {
				this.$http.get("languages")
				.then(response => {
					this.languages = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getOperations: function() {
				this.$http.get('admin/management/products/operation')
					.then(response => {
						this.operations = response.body
						this.operation = this.operations[0]
					})
			},
			getMeasurementsUnit: function() {
				this.$http.get('admin/management/measurement/unit')
					.then(response => {
						this.measurementsUnit = response.body
					})
			},
			getAttributeLists: function() {
				this.$http.get('admin/management/products/attribute/lists')
					.then(response => {
						this.attributeLists = response.body
					})
			},
			getProviders: function() {
				this.$http.get('admin/management/providers')
					.then(response => {
						this.providers = response.body
					})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
				})
			},
			update (data = false) {
				var that =  this
				var loadingTop = Ladda.create(this.$refs.btnUpdateTop)
				var loadingBottom = Ladda.create(this.$refs.btnUpdateBottom)
				loadingTop.start()
				loadingBottom.start()
				if(this.item.stockable) {
					if(!this.stock.usable_quantity) {
						this.stock.usable_quantity = 0;
						this.stock.quantity = 0;
					}
					this.item.stock = this.stock
				}
				this.$http.put('admin/management/products/' + this.item.id, this.item)
					.then(response => {
						this.reload()
						loadingTop.stop()
						loadingBottom.stop()
						this.$notify({
							group: 'topRight',
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
						/*
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
						*/
					}).catch(function(response) {
						console.log(response)
						loadingTop.stop()
						loadingBottom.stop()
					})
			},
			addAttribute() {
				if(this.attribute) {
						var loading = Ladda.create(this.$refs.btnAddAttribute)
						loading.start()
						this.$http.get('admin/management/products/' + this.item.id + '/add/attribute/' + this.attribute.id)
							.then(response => {
								var attribute = response.body
								loading.stop()
								this.item.attributes.push(attribute)
								this.calculateTotalMeasurementUnit()
								this.calculatePurchaseTotal()
								this.calculateTotal()
								this.update(true)
							}).catch(function(response) {
								loading.stop()
								console.log(response)
							})
				}
			},
			quitAttribute(attribute) {
				var ref = '#btn-quit-attribute-' + attribute.id
				var loading = Ladda.create(document.querySelector(ref))
				loading.start()
				this.$http.get('admin/management/products/' + this.item.id + '/quit/attribute/' + attribute.id)
					.then(response => {
						let index = this.item.attributes.indexOf(attribute)
						this.item.attributes.splice(index, 1)
						this.calculateTotalMeasurementUnit()
						this.calculatePurchaseTotal()
						this.calculateTotal()
						this.item.attributes.map(function(attr) {
							if(attr.product_attribute_id == attribute.id) {
								attr.product_attribute_id = null
							}
						})
						this.update(true)
						loading.stop()
					}).catch(function(response) {
						loading.stop()
						console.log(response)
					})
			},
			addMedia(media) {
				if(media) {
					if(media.aggregate_type == 'image') {
						this.item.media.images.push(media)
					} else {
						this.item.media.docs.push(media)
					}
				}
			},
			changeAttributeValue(attribute) {
				if(attribute.product_attribute_id) {
					var parent = null
					this.item.attributes.find(function(element) {
						if(element.id == attribute.product_attribute_id) {
							parent = element
						}

					})
					if(parent) {
						if(parent.childs) {
							if(parent.childs.length) {
								parent.childs.find(function(element, key) {
									if(element.id == attribute.id) {
										parent.childs[key] = attribute
									}

								})

								var that = this
								var operation = ''

								parent.childs.forEach(function(attr, key) {
									var value = null
									if(attr.product_attribute_type_field_id == 1) {
										if(attr.value) {
											value = attr.value.decimal_value
										}
									}
									if(attr.product_attribute_type_field_id == 2) {
										if(attr.value) {
											value = attr.value.integer_value
										}
									}

									if(value) {
										operation += value
										if(parent.childs.length - 1 > key) {
											operation += parent.operator.symbol
										}
									}
								})
								if(operation) {
									var total = eval(operation)
									if(parent.product_attribute_type_field_id == 1) {
										parent.value.decimal_value = Number(parseFloat(total).toFixed(3))
									}
									if(parent.product_attribute_type_field_id == 2) {
										parent.value.integer_value = Number(total)
									}
								}
							}
						}
					}
				}
				this.calculateTotalMeasurementUnit()
			},
			changeOperation() {
				this.calculateTotalMeasurementUnit()
			},
			//--
			calculateTotalMeasurementUnit() {
				var that = this
				var attributes = this.item.attributes
				if(attributes.length) {
					if(this.item.product_operation_id == 1) {
						var total = 0
					}
					if(this.item.product_operation_id == 2) {
						var total = 1
					}

					attributes.forEach(function(attribute, key) {
						if(attribute.operation) {
							var value = null

							if(attribute.formula) {
								var val = null
								if(attribute.product_attribute_type_field_id == 1) {
									if(attribute.value) {
										val = attribute.value.decimal_value
									}
								}

								if(attribute.product_attribute_type_field_id == 2) {
									if(attribute.value) {
										val = attribute.value.integer_value
									}
								}

								if(val) {
									var result = null
									if(attribute.formula.product_operation_id == 1) {
										result = parseFloat(val) + parseFloat(attribute.formula.value)
									}
									if(attribute.formula.product_operation_id == 2) {
										result = parseFloat(val) * parseFloat(attribute.formula.value)
									}
									if(result) {
										attribute.formula.total = parseFloat(result).toFixed(3)
										value = result
									}
								}
							} else {
								if(attribute.product_attribute_type_field_id == 1) {
									value = attribute.value.decimal_value
								}

								if(attribute.product_attribute_type_field_id == 2) {
									value = attribute.value.integer_value
								}
							}


							if(value) {
								if(that.item.product_operation_id == 1) {
									total = total + parseFloat(value)
								}
								if(that.item.product_operation_id == 2) {
									total = total * parseFloat(value)
								}
							}
						}
					})
					if(total == 0) {
						total = 1
					}
					this.item.total_measurement_unit = parseFloat(total).toFixed(3)
				} else {
					this.item.total_measurement_unit = 1
				}
			},

			//-- SALES
				calculateDiscount() {
					if(this.item.base_price) {
						var base_price = parseFloat(this.item.base_price)
					} else {
						var base_price = 0
					}

					if(this.item.save) {
						var save = parseFloat(this.item.save)
					} else {
						var save = 0
					}

					if(save > base_price) {
						this.item.save = -Math.abs(save)
					}

					var discount = save * 100 / base_price

					this.item.discount = parseFloat(discount).toFixed(2)
					this.$nextTick( () => this.$refs.profit.calculateProfit())
				},
				calculateSave() {
					if(this.item.base_price) {
						var base_price = parseFloat(this.item.base_price)
					} else {
						var base_price = 0
					}

					if(this.item.discount) {
						var discount = parseFloat(this.item.discount)
					} else {
						var discount = 0
					}

					if(this.item.discount > 100) {
						var total = -Math.abs(base_price * discount / 100)
					} else {
						var total = base_price * discount / 100
					}

					this.item.save = parseFloat(total).toFixed(2)
					this.$nextTick( () => this.$refs.profit.calculateProfit())
				},
				calculatePrice() {
					if(this.item.base_price) {
						var base_price = parseFloat(this.item.base_price)
					} else {
						var base_price = 0
					}

					if(this.item.save) {
						var save = parseFloat(this.item.save)
					} else {
						var save = 0
					}

					var price = base_price - Math.abs(save)

					this.item.price = parseFloat(price).toFixed(2)
				},
				calculateTaxes() {
					if(this.tax) {
						if(this.item.price) {
							var price = parseFloat(this.item.price)
						} else {
							var price = 0
						}
						var taxes = price * this.tax.value / 100
						this.item.taxes = parseFloat(taxes).toFixed(2)
					} else {
						this.item.taxes = 0
					}
					this.$nextTick( () => this.$refs.profit.calculateProfit())
				},
				calculateAmount() {
					if(this.item.price) {
						var price = parseFloat(this.item.price)
					} else {
						var price = 0
					}

					if(this.item.taxes) {
						var taxes = parseFloat(this.item.taxes)
					} else {
						var taxes = 0
					}

					var sale_price = price + taxes

					this.item.amount = parseFloat(sale_price).toFixed(2)
				},
				calculateTotal() {
					if(this.item.amount) {
						var amount = parseFloat(this.item.amount)
					} else {
						var amount = 0
					}

					if(this.item.total_measurement_unit) {
						var total_measurement_unit = parseFloat(this.item.total_measurement_unit)
					} else {
						var total_measurement_unit = 0
					}

					var total = total_measurement_unit * amount

					var extras = this.item.extras
					if(extras.length) {
						extras.forEach(function(extra) {
							var value = Number(extra.sale_value)
							total = total + value
						})
					}
					
					this.item.total = parseFloat(total).toFixed(2)
					this.calculateTotalPriceOutExtras()
				},
				//-- EVENTS
					discountChange() {
						this.item.discount = this.$options.filters.checkDecimals(this.item.discount)
						this.calculateSave()
						this.calculatePrice()
						this.calculateTaxes()
						this.calculateAmount()
						this.calculateTotal()
					},
					saveChange() {
						this.item.save = this.$options.filters.checkDecimals(this.item.save)
						this.calculateDiscount()
						this.calculatePrice()
						this.calculateTaxes()
						this.calculateAmount()
						this.calculateTotal()
					},
			//-- SALES

			//-- PURCHASE
				calculatePurchaseDiscount() {
					if(this.item.purchase_base_price) {
						var purchase_base_price = parseFloat(this.item.purchase_base_price)
					} else {
						var purchase_base_price = 0
					}

					if(this.item.purchase_save) {
						var purchase_save = parseFloat(this.item.purchase_save)
					} else {
						var purchase_save = 0
					}

					if(purchase_save > purchase_base_price) {
						this.item.purchase_save = -Math.abs(purchase_save)
					}

					var purchase_discount = purchase_save * 100 / purchase_base_price

					this.item.purchase_discount = parseFloat(purchase_discount).toFixed(2)
				},
				calculatePurchaseSave() {
					if(this.item.purchase_base_price) {
						var purchase_base_price = parseFloat(this.item.purchase_base_price)
					} else {
						var purchase_base_price = 0
					}

					if(this.item.purchase_discount) {
						var purchase_discount = parseFloat(this.item.purchase_discount)
					} else {
						var purchase_discount = 0
					}

					if(this.item.purchase_discount > 100) {
						var total = -Math.abs(purchase_base_price * purchase_discount / 100)
					} else {
						var total = purchase_base_price * purchase_discount / 100
					}
					this.item.purchase_save = parseFloat(total).toFixed(2)
				},
				calculatePurchasePrice() {
					if(this.item.purchase_base_price) {
						var purchase_base_price = parseFloat(this.item.purchase_base_price)
					} else {
						var purchase_base_price = 0
					}

					if(this.item.purchase_save) {
						var purchase_save = Math.abs(parseFloat(this.item.purchase_save))
					} else {
						var purchase_save = 0
					}

					var purchase_price = purchase_base_price - purchase_save
					this.item.purchase_price = parseFloat(purchase_price).toFixed(2)
				},
				calculatePurchaseTaxes() {
					if(this.tax) {
						if(this.item.purchase_price) {
							var purchase_price = parseFloat(this.item.purchase_price)
						} else {
							var purchase_price = 0
						}
						var taxes = purchase_price * this.tax.value / 100
						this.item.purchase_taxes = parseFloat(taxes).toFixed(2)
					} else {
						this.item.purchase_taxes = 0
					}
				},
				calculatePurchaseAmount() {
					if(this.item.purchase_price) {
						var purchase_price = parseFloat(this.item.purchase_price)
					} else {
						var purchase_price = 0
					}

					if(this.item.purchase_taxes) {
						var purchase_taxes = parseFloat(this.item.purchase_taxes)
					} else {
						var purchase_taxes = 0
					}

					var purchase_amount = purchase_price + purchase_taxes

					this.item.purchase_amount = parseFloat(purchase_amount).toFixed(2)
				},
				calculatePurchaseTotal() {
					if(this.item.purchase_amount) {
						var purchase_amount = parseFloat(this.item.purchase_amount)
					} else {
						var purchase_amount = 0
					}

					if(this.item.total_measurement_unit) {
						var total_measurement_unit = parseFloat(this.item.total_measurement_unit)
					} else {
						var total_measurement_unit = 1
					}

					var purchase_total = purchase_amount * total_measurement_unit

					var extras = this.item.extras
					if(extras.length) {
						extras.forEach(function(extra) {
							var value = Number(extra.purchase_value)
							purchase_total = purchase_total + value
						})
					}

					this.item.purchase_total = parseFloat(purchase_total).toFixed(2)
					this.calculatePurchaseTotalPriceOutExtras()
				},
				//--EVENTS
					purchaseDiscountChange() {
						this.item.purchase_discount = this.$options.filters.checkDecimals(this.item.purchase_discount)
						this.calculatePurchaseSave()
						this.calculatePurchasePrice()
						this.calculatePurchaseTaxes()
						this.calculatePurchaseAmount()
						this.calculatePurchaseTotal()
					},
					purchaseSaveChange() {
						this.item.purchase_save = this.$options.filters.checkDecimals(this.item.purchase_save)
						this.calculatePurchaseDiscount()
						this.calculatePurchasePrice()
						this.calculatePurchaseTaxes()
						this.calculatePurchaseAmount()
						this.calculatePurchaseTotal()
					},
			//-- PURCHASE

			openViewAttribute(attribute) {
				var loading = Ladda.create(document.querySelector('#view-all-attribute-values-' + attribute.id))
				loading.start()
				this.viewAttribute = attribute
				this.$http.get('admin/management/products/' + this.viewAttribute.product_id + '/attributes/' + this.viewAttribute.id  + '/values')
				.then(response => {
					loading.stop()
					this.options = response.body.options
					this.values = response.body.values
					this.filter()
					var modal = $('#modal-attribute')
					modal.modal('show')
				})
			},

			filter() {
				var that = this
				if(this.options) {
					if(this.options.length) {
						this.options.forEach(function(option) {
							that.$set(option, 'selected', false)
						})

						if(this.values) {
							if(this.values.length) {
								this.options.forEach(function(option) {
									var found = that.values.find(function(value) {
										return option.id == value.id;
									})
									if(found) {
										option.selected = true
									} else {
										option.selected = false
									}
								})
							}
						}
					}
				}
			},

			quitValue(value) {
				value.selected = false
				var option = this.values.find(function(element) {
					return element.id == value.id
				})
				if(option) {
					let index = this.values.indexOf(option)
					this.$delete(this.values, index)
					this.removeAttributeValue(value, this.viewAttribute)
				}
			},

			addValue(value) {
				value.selected = true
				var selected = Object.assign({}, value)
				this.values.push(selected)
				this.addAttributeValue(value, this.viewAttribute)
			},

			selectAll() {
				var loading = Ladda.create(this.$refs.btnSelectAll)
				loading.start()
				this.$http.get('admin/management/products/' + this.viewAttribute.product_id + '/attributes/' + this.viewAttribute.id  + '/add/value/all')
				.then(response => {
					this.values = Object.assign([], this.options)
					this.filter()
					loading.stop()
					this.$notify({
						group: 'topRight',
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				})
			},

			deselectAll() {
				var loading = Ladda.create(this.$refs.btnDeselectAll)
				loading.start()
				this.$http.get('admin/management/products/' + this.viewAttribute.product_id + '/attributes/' + this.viewAttribute.id  + '/destroy/value/all')
				.then(response => {
					this.values = []
					this.filter()
					loading.stop()
					this.$notify({
						group: 'topRight',
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				})
			},

			calculateTotalPriceOutExtras() {
				if(this.item.total) {
					var total = parseFloat(this.item.total)
				} else {
					var total = 0
				}

				var extras = this.item.extras
				if(extras.length) {
					extras.forEach(function(extra) {
						var value = Number(extra.sale_value)
						total = total - value
					})
				}

				var total_price_out_extras = total
				this.totalPriceOutExtras = parseFloat(total_price_out_extras).toFixed(2)
			},
			calculatePurchaseTotalPriceOutExtras() {
				if(this.item.purchase_total) {
					var purchase_total = parseFloat(this.item.purchase_total)
				} else {
					var purchase_total = 0
				}

				var extras = this.item.extras
				if(extras.length) {
					extras.forEach(function(extra) {
						var value = Number(extra.purchase_value)
						purchase_total = purchase_total - value
					})
				}

				var total_price_out_extras = purchase_total
				this.purchaseTotalPriceOutExtras = parseFloat(total_price_out_extras).toFixed(2)
			},
			attributesUpdated(attributes) {
				this.item.attributes = attributes
				this.calculateTotalMeasurementUnit()
				this.calculateTotal()
				this.calculatePurchaseTotal()
				this.update()
			},
			attributeFormulaUpdated() {
				this.calculateTotalMeasurementUnit()
				this.calculateTotal()
				this.calculatePurchaseTotal()
				this.update()
			},
			createFormula(attribute) {
				var that =  this
				var value = null
				if(attribute.value) {
					if(attribute.product_attribute_type_field_id == 1) {
						value = attribute.value.decimal_value
					}
					if(attribute.product_attribute_type_field_id == 2) {
						value = attribute.value.integer_value
					}
				}
				var formula = {
					value: 1,
					product_operation_id: 2,
					total: value,
					product_attribute_id: attribute.id
				}
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.formula_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/products/attribute/formula', formula)
							.then(response => {
								var attributes = response.body.data
								that.item.attributes = attributes
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
								that.$emit('reload')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			operationsUpdated() {
				this.calculateTotalMeasurementUnit()
				this.calculateTotal()
				this.calculatePurchaseTotal()
				this.update()
			},
			updatedExtra() {
				this.calculateTotal()
				this.calculatePurchaseTotal()
			},
			normalizerTreeselectCategory(node) {
				return {
					id: node.id,
					label: node.title,
					children: node.children,
				}
			},
			removeAttributeValue(value, attribute) {
				if(value) {
					this.$http.get('admin/management/products/' + attribute.product_id + '/attributes/' + attribute.id  + '/destroy/value/' + value.id)
					.then(response => {
						this.filter()
						this.$notify({
							group: 'topRight',
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					})
				}
			},
			addAttributeValue(value, attribute) {
				this.$http.get('admin/management/products/' + attribute.product_id + '/attributes/' + attribute.id  + '/add/value/' + value.id)
				.then(response => {
					attribute.values = []
					this.filter()
					this.clearSearchAttributeValues()
					this.$notify({
						group: 'topRight',
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				})
			},
			searchAttributeValues(query, attribute) {
				this.clearSearchAttributeValues()
				this.searchAttributeValuesLoading = true
				var data = {
					text: query,
				}
				this.$http.post('admin/management/products/' + attribute.product_id + '/attributes/' + attribute.id  + '/seacrh/values', data)
				.then(response => {
					this.valuesMultiselectSearch = response.body
					this.searchAttributeValuesLoading = false
				})
			},
			clearSearchAttributeValues() {
				this.valuesMultiselectSearch = []
			},
			addCatalog() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: "El producto se añadirá al catálogo",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/products/' + that.item.id + '/add/catalog')
							.then(response => {
								that.item.display_on_catalog = true
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			removeCatalog() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: "El producto se eliminará del catálogo",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/products/' + that.item.id + '/add/remove')
							.then(response => {
								that.item.display_on_catalog = false
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/views/Edit.vue